"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import {
  isInternalAppHref,
  resumeDashboardActivity,
  suspendDashboardActivity,
} from "@/lib/dashboard/dashboardActivityGate";
import { isDashboardLikePath } from "@/lib/telegram/telegramPaths";

/**
 * Pauses dashboard polling/sockets on internal navigation clicks and route changes
 * so leaving dashboard-like routes feels instant.
 */
export default function DashboardActivityGate() {
  const pathname = usePathname();
  const pathnameRef = useRef(pathname);

  useEffect(() => {
    pathnameRef.current = pathname;
    if (isDashboardLikePath(pathname)) {
      resumeDashboardActivity();
    }
  }, [pathname]);

  useEffect(() => {
    const onClickCapture = (event) => {
      if (!isDashboardLikePath(pathnameRef.current)) return;
      const target = event.target;
      if (!(target instanceof Element)) return;
      const anchor = target.closest("a[href]");
      if (!anchor) return;
      const href = anchor.getAttribute("href");
      if (!href || !isInternalAppHref(href)) return;
      const pathOnly = href.split(/[?#]/)[0];
      if (isDashboardLikePath(pathOnly)) return;
      suspendDashboardActivity();
    };

    document.addEventListener("click", onClickCapture, true);
    return () => document.removeEventListener("click", onClickCapture, true);
  }, []);

  useEffect(() => {
    const prev = pathnameRef.current;
    if (isDashboardLikePath(prev) && !isDashboardLikePath(pathname)) {
      suspendDashboardActivity();
    }
  }, [pathname]);

  return null;
}
